
/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export function checkPermission(value) {
  return true // 暂时屏蔽权限认证
  // if (value && value instanceof Array && value.length > 0) {
  //   const authorities = store.getters && store.getters.authorities
  //   let permission = value

  //   const hasPermission = authorities.some(auth => {
  //     return permission.includes(auth)
  //   })

  //   if (!hasPermission) {
  //     return false
  //   }
  //   return true
  // } else {
  //   console.error(`need roles! Like v-permission="['admin','editor']"`)
  //   return false
  // }
}
